/**
 * Helper for any date format type
 * @author Allan Rothenburg
 * @date 11/02/2022
 */

import moment from "moment";
moment.locale("pt-br");

export default {
  methods: {
    formattedDateToDate: function formattedDateToDate(date) {
      let dia = date.split("/")[0];
      let mes = date.split("/")[1];
      let ano = date.split("/")[2];

      return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia).slice(-2);
    },
    /**
     * DD/MM/YYYY
     * @param String date
     * @returns String formattedDate
     * @date 11/02/2022
     */
    toL: function toL(date) {
      return moment(date).format("L");
    },
    /**
     * HH:MM
     * @param String date
     * @returns String formattedDate
     * @date 11/02/2022
     */
    toLT: function toLT(date) {
      return moment(date).format("LT");
    },
    /**
     * DD/MM/YYYY HH:MM
     * @param String date
     * @returns String formattedDate
     * @date 11/02/2022
     */
    toLLT: function toLLT(date) {
      return `${moment(date).format("L")} ${moment(date).format("LT")}`;
    },
    /**
     * day: Segunda-feira
     * month: Janeiro
     * dmy: 01 de janeiro de 1970
     * dmyh: 01 de janeiro de 1970 às 00:00
     * detailed: segunda-feira, 01 de janeiro de 1970 às 00:00
     * @param String date
     * @param String type
     * @returns String formattedDate
     * @date 11/02/2022
     */
    toName: function toName(date, type) {
      switch (type) {
        case "day":
          return capitalizeFirstLetter(moment(date).format("dddd"));
        case "month":
          return capitalizeFirstLetter(moment(date).format("MMMM"));
        case "dmy":
          return moment(date).format("LL");
        case "dmyh":
          return moment(date).format("LLL");
        case "detailed":
          return moment(date).format("LLLL");
      }
    },
    /**
     * Verify if date is expired
     * @param String date
     * @returns Boolean
     * @date 05/11/2022
     */
    isExpired: function isExpired(date) {
      return moment(date).isBefore(moment());
    },
  },
};

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
